import DeliveryService from "../DeliveryService";

const Delivery = {
  formData(data) {
    let form = new FormData();
    for (let obj in data) {
      form.append(obj, data[obj]);
    }
    return form;
  },
  getShops() {
    const url = `/shops`;
    return DeliveryService.get(url);
  },
  getProductByShop(shopId, parent_id = null) {
    let params = "";
    if (parent_id != null) {
      params = "?parent_id=" + parent_id;
    }
    const url = `/console/shops/` + shopId + `/products` + params;
    return DeliveryService.get(url);
  },
  addOrder(data) {
    const url = `/console/admin/order/add`;
    return DeliveryService.post(url, data);
  },
  getDeliveryFee(data) {
    const url = `/delivery/fee/quotation`;
    return DeliveryService.post(url, data);
  },
  getClusterDriverFee(data) {
    const url = `/console/orders/cluster/driver`;
    return DeliveryService.post(url, data);
  },
  requestClusterDriver(data) {
    const url = `/console/orders/cluster/driver-request`;
    return DeliveryService.post(url, data);
  },
};

export default Delivery;
